(() => {
  const GENERIC_GUIDE = "https://support.ivintree.com/hc/en-us/articles/61318773566873-How-to-Join-Broadcast-with-Hearing-Aids";
  const DIRECT_INSTRUCTION = "Open your hearing-aid app and join the venue broadcast.";
  const NO_DIRECT_SUPPORT = "Direct Auracast is not currently supported for this brand.";
  const COMING_SOON_GUIDES = new Set(["Amplifon", "Audibel", "Danavox", "Interton"]);
  const ADDITIONAL_BRAND_LOGOS = {
  "Miracle-Ear": "https://www.miracle-ear.com/content/dam/amplifon-america/icon/layout_set_logo.png/jcr:content/renditions/cq5dam.web.1280.1280.png",
  "Hansaton": "https://www.hansaton.com/content/experience-fragments/hansaton/int/en/site/header/for-consumers/_jcr_content/root/header_copy/logoDesktop.coreimg.png/1746163052851/ht-logo-horizontal-grey-rgb.png",
  "Audio Service": "https://cdn.audioservice.com/-/media/audioservice/global/images/logos/audio-service---blue---rgb.svg?rev=b713ae8ab4b648eba835f6f4cba38be8&extension=webp&hash=045CE54967ABCCB432ACF58A586D294F"
};
  const BRAND_GUIDES = {
    Beltone: {
      url: "https://ivintree.com/pages/beltone-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b8bef32bbf6ac360a61567.png?ts=1784622511273",
      models: ["Commence", "Envision", "Serene"]
    },
    Bernafon: {
      url: "https://ivintree.com/pages/bernafon-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b8bf132bbf6ac360a620d7.png?ts=1774590015886",
      models: ["Encanta"]
    },
    Jabra: {
      url: "https://ivintree.com/pages/jabra-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b92123caec56d992a84032.png?ts=1778634983680",
      models: ["Enhance Pro 20", "Enhance Pro 30", "Enhance Select 500"]
    },
    Oticon: {
      url: "https://ivintree.com/pages/oticon-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69a78c03df52a20580380f32.png?ts=1774520463225",
      models: ["Intent", "Zeal"]
    },
    Philips: {
      url: "https://ivintree.com/pages/philips-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b9213910af80322e525bbd.png?ts=1774520398641",
      models: ["HearLink 9050"]
    },
    Phonak: {
      url: "https://ivintree.com/pages/phonak-hearing-aids-auracast-guide",
      models: []
    },
    ReSound: {
      url: "https://ivintree.com/pages/resound-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b9215eb0b6d7294e7cb711.png?ts=1778635190636",
      models: ["Enzo IA", "Nexia", "Savi", "Vivia"]
    },
    Starkey: {
      url: "https://ivintree.com/pages/starkey-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b27be57c4f35775b409e40.png?ts=1781746108000",
      models: ["Edge AI", "Genesis AI", "Omega AI"]
    },
    Widex: {
      url: "https://ivintree.com/pages/widex-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69c5fb4b00b557dea7751c47.png?ts=1774600245504",
      models: ["Allure"]
    },
    Cochlear: {
      url: "https://ivintree.com/pages/cochlear-hearing-aids-auracast-guide",
      models: []
    },
    Danalogic: {
      url: "https://ivintree.com/pages/danalogic-hearing-aids-auracast-guide",
      models: []
    },
    NuEar: {
      url: "https://ivintree.com/pages/nuear-hearing-aids-auracast-guide",
      models: []
    },
    Fortell: {
      url: "https://ivintree.com/pages/fortell-hearing-aids-auracast-guide",
      models: []
    }
  };

  const escapeHtml = (value) => String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const isDirect = (row) => /^✓ Yes/.test(row.aur);
  const hasTelecoil = (row) => {
    const value = row.tele.trim();
    if (!value) return false;
    if (/^✕ No/.test(value)) return false;
    if (/^Not (?:listed|verified)/i.test(value)) return false;
    if (/^Check exact style$/i.test(value)) return false;
    return true;
  };
  const hasPhonePath = (row) => /^(?:✓ Yes\b|Via\b)/i.test(row.phone.trim());
  const routeFor = {
    direct: (row) => isDirect(row),
    telecoil: (row) => !isDirect(row) && hasTelecoil(row),
    bluetooth: (row) => !isDirect(row) && hasPhonePath(row)
  };
  const routeMeta = [
    {
      key: "direct",
      title: "Direct Auracast",
      text: "No extra receiver needed."
    },
    {
      key: "telecoil",
      title: "T-coil + AuraCoil",
      text: "Listen through an AuraCoil neckloop and your hearing aid’s T or MT program."
    },
    {
      key: "bluetooth",
      title: "Bluetooth + Aura C",
      text: "Listen through your phone with Aura C and Venucast Connect."
    }
  ];

  const hintFor = (row, route) => {
    if (route === "direct") {
      const hint = row.aur.replace(/^✓ Yes\s*[–-]?\s*/, "");
      return hint && hint !== row.aur ? hint : "";
    }
    if (route === "telecoil" && !/^✓ Yes$/.test(row.tele)) {
      if (/^(?:✓ Yes\s*\/\s*)?model dependent$/i.test(row.tele)) return "Only some styles include a telecoil; confirm your exact style";
      if (/^Some models$/i.test(row.tele)) return "Only some styles include a telecoil; confirm your exact style";
      return row.tele;
    }
    if (route === "bluetooth") {
      if (Object.prototype.hasOwnProperty.call(ADDITIONAL_BRAND_LOGOS, row.brand)) return "Requires media streaming from a compatible USB-audio phone and app; this Aura C combination has not been individually tested.";
      if (/wireless styles|model dependent|accessor|limited|Android via|except|only on|not CIC|compatible EON|not listed|app connectivity/i.test(row.phone)) return row.phone;
      if (/style-dependent|wireless styles|phone combination/i.test(row.note)) return "Confirm exact style and phone support.";
    }
    return "";
  };

  const releaseYearSortValue = (value) => {
    const years = String(value).match(/\b(?:19|20)\d{2}\b/g);
    return years ? Math.max(...years.map(Number)) : Number.NEGATIVE_INFINITY;
  };

  const rowsByYear = (rows) => {
    const years = new Map();
    rows
      .slice()
      .sort((a, b) => releaseYearSortValue(b.year) - releaseYearSortValue(a.year) || a.model.localeCompare(b.model))
      .forEach((row) => {
        if (!years.has(row.year)) years.set(row.year, []);
        years.get(row.year).push(row);
      });
    return years;
  };

  const brandLogo = (brand, assets, heading) => {
    const src = assets.brands[brand] || ADDITIONAL_BRAND_LOGOS[brand];
    if (src) {
      return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(brand) + '" loading="lazy"' + (heading ? ' width="145" height="45"' : ' width="86" height="35"') + ">";
    }
    return '<span class="brand-fallback">' + escapeHtml(brand) + "</span>";
  };

  document.querySelectorAll("[data-ha-compatibility]").forEach(async (root) => {
    if (root.dataset.haInitialized === "true") return;
    root.dataset.haInitialized = "true";

    const assets = JSON.parse(root.querySelector("[data-ha-assets]").textContent);
    let normalizedRows = [];
    try {
      const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRqcrRs43b8u0ULSY9jEeBAYntGMxyWEUqICiUaYEN1_lqUN2ZivsW1_IO00rKhio3sHN7i2dcNS7jr/pub?gid=0&single=true&output=csv" + "&_=" + Date.now(), { cache: "no-store" });
      if (!response.ok) throw new Error("Shared data unavailable");
      const csv = await response.text();
      const table = [];
      let fields = [], field = "", quoted = false;
      for (let i = 0; i < csv.length; i++) {
        const char = csv[i];
        if (char === '"') {
          if (quoted && csv[i + 1] === '"') { field += '"'; i++; }
          else quoted = !quoted;
        } else if (char === "," && !quoted) {
          fields.push(field); field = "";
        } else if ((char === "\n" || char === "\r") && !quoted) {
          if (char === "\r" && csv[i + 1] === "\n") i++;
          fields.push(field); table.push(fields); fields = []; field = "";
        } else field += char;
      }
      if (field || fields.length) { fields.push(field); table.push(fields); }
      const headers = table.shift().map((value) => value.replace(/^\uFEFF/, "").trim());
      const columns = ["Brand", "Model", "Release year", "Auracast support", "Telecoil support", "Phone streaming", "Notes", "Source URL"];
      if (columns.some((name) => !headers.includes(name))) throw new Error("Invalid shared data headers");
      normalizedRows = table.filter((values) => values.some((value) => value.trim())).map((values) => {
        const value = (name) => (values[headers.indexOf(name)] || "").trim();
        return { brand: value("Brand"), model: value("Model"), year: value("Release year"), aur: value("Auracast support"), tele: value("Telecoil support"), phone: value("Phone streaming"), note: value("Notes"), url: value("Source URL") };
      });
      if (normalizedRows.some((row) => !row.brand || !row.model)) throw new Error("Invalid shared data record");
    } catch (error) {
      normalizedRows = [];
    }
    const brandsEl = root.querySelector('[data-ha-role="brands"]');
    const brandNameEl = root.querySelector('[data-ha-role="brandname"]');
    const groupsEl = root.querySelector('[data-ha-role="groups"]');
    const choiceEl = root.querySelector('[data-ha-role="choice"]');
    const searchEl = root.querySelector('[data-ha-role="search"]');
    const clearSearchEl = root.querySelector('[data-ha-role="clear-search"]');
    const searchStatusEl = root.querySelector('[data-ha-role="search-status"]');
    const directGuideEl = root.querySelector('[data-ha-role="direct-guide"]');
    const directGuideCoverEl = root.querySelector('[data-ha-role="direct-guide-cover"]');
    const directGuideCoverImageEl = root.querySelector('[data-ha-role="direct-guide-cover-image"]');
    const directScopeEl = root.querySelector('[data-ha-role="direct-scope"]');
    const directInstructionEl = root.querySelector('[data-ha-how="direct"] .how-card__content > div > p:not(.how-card__scope)');
    const howCards = Array.from(root.querySelectorAll("[data-ha-how]"));

    howCards.filter((card) => ['telecoil', 'bluetooth'].includes(card.dataset.haHow)).forEach((card) => {
      const primary = card.querySelector('.method-primary');
      const product = card.querySelector('.how-card__product');
      const links = card.querySelector('.how-card__links');
      if (!primary || !product || !links || card.querySelector('.receiver-action')) return;
      const action = document.createElement('div');
      action.className = 'receiver-action';
      const label = document.createElement('span');
      label.className = 'receiver-action__label';
      label.textContent = card.dataset.haHow === 'telecoil' ? 'View AuraCoil' : 'View Aura C';
      const productImage = product.querySelector('img');
      if (productImage) productImage.src = card.dataset.haHow === 'telecoil' ? 'https://cdn.shopify.com/s/files/1/0858/9892/0229/files/ha-auracoil-transparent-20261023.png?v=1792749441' : 'https://cdn.shopify.com/s/files/1/0858/9892/0229/files/ha-aura-c-transparent-20261023.png?v=1792749441';
      product.appendChild(label);
      product.target = '_blank';
      product.rel = 'noopener noreferrer';
      product.setAttribute('aria-label', label.textContent + ' product (opens in a new tab)');
      action.append(product, primary);
      links.replaceWith(action);
    });
    const howToGridEl = root.querySelector(".how-to__grid");

    if (!normalizedRows.length) {
      brandsEl.innerHTML = "";
      brandNameEl.innerHTML = "<h2>Hearing aid compatibility</h2>";
      groupsEl.innerHTML = '<p class="empty">Hearing aid compatibility data is temporarily unavailable. Please try again later.</p>';
      searchEl.disabled = true;
      return;
    }

    const brands = Array.from(new Set(normalizedRows.map((row) => row.brand)))
      .sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
    let selectedBrand = null;
    const returnState = history.state && history.state.haGuide;

    const saveVisit = () => {
      if (!selectedBrand) return;
      try {
        history.replaceState({ ...history.state, haGuide: { brand: selectedBrand, scrollY: window.scrollY } }, "");
      } catch (error) {
        // The guide remains usable when browser history storage is unavailable.
      }
    };
    window.addEventListener("pagehide", saveVisit);
    root.addEventListener("click", (event) => {
      const link = event.target.closest("a[href]");
      if (link && !link.getAttribute("href").startsWith("#")) saveVisit();
    });

    const setGuide = (brand) => {
      const guide = BRAND_GUIDES[brand];
      directGuideEl.classList.remove("landscape-guide", "landscape-guide--text");
      const guideComingSoon = COMING_SOON_GUIDES.has(brand);
      const directSupported = normalizedRows.some((item) => item.brand === brand && isDirect(item));
      let href = guide ? guide.url : GENERIC_GUIDE;
      let scope = guideComingSoon
        ? "The " + brand + " connection guide is being prepared and will be available soon."
        : guide
          ? ""
          : "A brand-specific guide is not available yet. This link opens general connection steps.";

      directInstructionEl.textContent = directSupported ? DIRECT_INSTRUCTION : NO_DIRECT_SUPPORT;
      directInstructionEl.hidden = true;
      directGuideEl.hidden = !directSupported || guideComingSoon;
      directScopeEl.hidden = !directSupported || (!guideComingSoon && !scope);
      if (directSupported) {
        if (guideComingSoon) {
          directGuideEl.removeAttribute("href");
          directGuideEl.textContent = "";
          directScopeEl.classList.add("is-coming-soon");
          directScopeEl.innerHTML =
            '<span class="how-card__status">Coming soon</span>' +
            "<strong>Connection guide in preparation</strong>" +
            "<span>The " + escapeHtml(brand) + " guide will be available soon.</span>";
        } else {
          const directStepAnchor = {
            Beltone: "beltone-app-heading",
            Bernafon: "bernafon-app-title",
            Cochlear: "join",
            Danalogic: "panel-app",
            Fortell: "join",
            Jabra: "setup",
            NuEar: "join-nuear",
            Oticon: "panel-app",
            Philips: "panel-app",
            Phonak: "join",
            ReSound: "panel-app",
            Starkey: "join",
            Widex: "join"
          }[brand];
          directGuideEl.href = directStepAnchor ? href.split("#")[0] + "#" + directStepAnchor : href;
          directGuideEl.textContent = 'View ' + brand + ' connection steps';
          directGuideEl.setAttribute("aria-label", "View " + brand + " connection steps on Avantree");
          directScopeEl.classList.remove("is-coming-soon");
          directScopeEl.textContent = scope;
        }
      } else {
        directGuideEl.removeAttribute("href");
        directGuideEl.textContent = "";
        directScopeEl.classList.remove("is-coming-soon");
        directScopeEl.textContent = "";
      }

      const previews = root.querySelectorAll('.how-card__brand-preview, .how-card__broadcast-preview');
      previews.forEach((preview) => preview.classList.remove("is-active-cover"));
      directGuideCoverEl.classList.remove("is-active-cover");
      const preview = Array.from(previews).find((item) => item.dataset.coverBrand === brand ||
        (brand === "ReSound" && item.classList.contains("how-card__broadcast-preview")));
      const canShowCover = directSupported && !guideComingSoon && !!guide;
      directGuideCoverEl.hidden = true;
      directGuideCoverImageEl.removeAttribute("src");
      directGuideCoverImageEl.alt = "";
      if (canShowCover) {
        const devices = preview && preview.querySelector('.how-card__resound-devices');
        directGuideEl.classList.add("landscape-guide");
        directGuideEl.classList.toggle("landscape-guide--text", !devices);
        directGuideEl.style.setProperty('--guide-accent', '#315805');
        directGuideEl.style.setProperty('--guide-accent-text', '#fff');
        directGuideEl.innerHTML = '<span class="guide-visual"></span><span class="guide-copy"><span class="guide-title">Join a broadcast<br><strong>directly</strong></span><span class="guide-start">See how</span></span>';
        const logo = preview && preview.querySelector('.how-card__resound-logo');
        if (logo) {
          const mark = logo.cloneNode(true);
          mark.className = 'guide-logo';
          mark.alt = 'Auracast';
          mark.width = 30;
          mark.height = 30;
          const lockup = document.createElement('span');
          lockup.className = 'guide-lockup';
          lockup.appendChild(mark);
          lockup.insertAdjacentHTML('beforeend', '<span class="guide-wordmark">AURACAST</span><span class="guide-tagline">A BLUETOOTH® TECHNOLOGY</span>');
          directGuideEl.querySelector('.guide-visual').appendChild(lockup);
        }
        if (devices) {
          const art = devices.cloneNode(true);
          art.classList.add('guide-art');
          art.querySelectorAll('img').forEach((img) => { img.alt = ''; });
          directGuideEl.querySelector('.guide-visual').appendChild(art);
        }
        directGuideEl.setAttribute('aria-label', 'See how to join an Auracast broadcast with ' + brand + ' hearing aids');
      }
    };

    // Keep Direct complete; progressively disclose older accessory-route models.
    const alignModelHeadings = () => {
      const desktop = window.matchMedia('(min-width: 861px)').matches;
      const frames = Array.from(groupsEl.querySelectorAll('.group__method .landscape-guide, .group__method .receiver-action'));
      frames.forEach((frame) => {
        frame.style.minHeight = '';
        let spacer = frame.previousElementSibling;
        if (!spacer || !spacer.classList.contains('action-alignment-spacer')) {
          spacer = document.createElement('div');
          spacer.className = 'action-alignment-spacer';
          spacer.setAttribute('aria-hidden', 'true');
          frame.before(spacer);
        }
        spacer.style.height = '0px';
        spacer.hidden = !desktop;
        spacer.style.display = desktop ? 'block' : 'none';
      });
      if (desktop) {
        const visibleFrames = frames.filter((frame) => frame.getBoundingClientRect().width > 0);
        if (visibleFrames.length) {
          const measurements = visibleFrames.map((frame) => ({ frame, rect: frame.getBoundingClientRect() }));
          const top = Math.max(...measurements.map(({ rect }) => rect.top));
          const height = Math.ceil(Math.max(...measurements.map(({ rect }) => rect.height)));
          measurements.forEach(({ frame, rect }) => {
            frame.previousElementSibling.style.height = Math.max(0, top - rect.top) + 'px';
            frame.style.minHeight = height + 'px';
          });
        }
      }
      const headings = Array.from(groupsEl.querySelectorAll('.models-heading'));
      headings.forEach((heading) => { heading.style.marginTop = ''; });
      if (!window.matchMedia('(min-width: 861px)').matches || !headings.length) return;
      const measurements = headings.map((heading) => ({ heading, top: heading.getBoundingClientRect().top }));
      const top = Math.max(...measurements.map((item) => item.top));
      measurements.forEach(({ heading, top: headingTop }) => {
        const gap = Math.max(0, top - headingTop);
        heading.style.marginTop = gap ? gap + 'px' : '';
      });
    };
    const setModelsExpanded = (group, expanded) => {
      const button = group.querySelector('[data-ha-model-toggle]');
      if (!button) return;
      group.querySelectorAll('[data-ha-older]').forEach((row) => { row.hidden = !expanded; });
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Show fewer models' : 'View all supported models (' + button.dataset.hiddenCount + ' more)';
    };
    const revealSearchModels = () => {
      const query = searchEl.value.trim().toLocaleLowerCase();
      if (!query || query === String(selectedBrand).toLocaleLowerCase()) return;
      groupsEl.querySelectorAll('.group').forEach((group) => {
        const matches = Array.from(group.querySelectorAll('[data-ha-older] .model-name')).some((model) =>
          (selectedBrand + ' ' + model.textContent).toLocaleLowerCase().includes(query));
        if (matches) setModelsExpanded(group, true);
      });
    };
    groupsEl.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ha-model-toggle]');
      if (button) setModelsExpanded(button.closest('.group'), button.getAttribute('aria-expanded') !== 'true');
    });
    window.addEventListener('resize', () => requestAnimationFrame(alignModelHeadings));
    document.fonts.ready.then(() => requestAnimationFrame(alignModelHeadings));
    groupsEl.addEventListener('load', () => requestAnimationFrame(alignModelHeadings), true);

    const renderRoute = (brandRows, meta) => {
      const routeRows = brandRows.filter(routeFor[meta.key]);
      const optionLabel = '<div class="option-label">Option ' + (routeMeta.indexOf(meta) + 1) + ' of 3</div>';
      if (!routeRows.length) {
        return '<article class="group ' + meta.key + '" id="option-' + meta.key + '">' + optionLabel +
          "<h3>" + meta.title + "</h3>" +
          '<p class="explainer">' + meta.text + "</p>" +
          '<p class="empty">No models currently listed for this option. Explore the other listening options.</p>' +
        "</article>";
      }

      const hints = Array.from(new Set(Array.from(rowsByYear(routeRows)).flatMap(([, rows]) => rows.map((row) => hintFor(row, meta.key))).filter(Boolean)));
      const markerFor = (hint) => "*".repeat(hints.indexOf(hint) + 1);
      const noteId = (hint) => "ha-note-" + meta.key + "-" + (hints.indexOf(hint) + 1);
      const yearGroups = Array.from(rowsByYear(routeRows));
      const canCollapse = meta.key !== 'direct' && yearGroups.length > 4;
      const hiddenCount = canCollapse ? yearGroups.slice(4).reduce((count, [, rows]) => count + rows.length, 0) : 0;
      const yearHtml = yearGroups.map(([year, rows], index) => {
        const modelHtml = rows.map((row) => {
          const hint = hintFor(row, meta.key);
          const hintHtml = hint ? '<sup class="model-marker" aria-hidden="true">' + markerFor(hint) + "</sup>" : "";
          return '<li class="model"' + (hint ? ' aria-describedby="' + noteId(hint) + '"' : "") + '>' +
            '<span class="model-name">' + escapeHtml(row.model) + "</span>" +
            hintHtml +
          "</li>";
        }).join("");
        return '<div class="yearrow"' + (canCollapse && index >= 4 ? ' data-ha-older hidden' : '') + '><strong>' + escapeHtml(year) + '</strong><ul class="yearrow__models"' + (year ? '' : ' style="grid-column: 1 / -1"') + ' aria-label="' + escapeHtml(year || 'Supported') + ' models">' + modelHtml + "</ul></div>";
      }).join("");

      const notesHtml = hints.length ? '<ul class="compatibility-notes" aria-label="Compatibility conditions">' + hints.map((hint) => {
        const condition = hint.replace(/^✓ Yes\s*[–/—-]?\s*/i, "").replace(/[.。]$/, "");
        return '<li id="' + noteId(hint) + '"><span class="note-marker">' + markerFor(hint) + '</span><span>' + escapeHtml(condition.charAt(0).toUpperCase() + condition.slice(1)) + ".</span></li>";
      }).join("") + "</ul>" : "";

      return '<article class="group ' + meta.key + '" id="option-' + meta.key + '">' + optionLabel +
        "<h3>" + meta.title + "</h3>" +
        '<p class="explainer">' + meta.text + "</p>" +
        '<div class="group__method" id="method-' + meta.key + '" data-ha-method="' + meta.key + '"></div>' +
        '<h4 class="models-heading">Supported models</h4>' +
        '<div class="models" id="ha-models-' + meta.key + '">' + yearHtml + "</div>" +
        (canCollapse ? '<button type="button" class="models-toggle" data-ha-model-toggle data-hidden-count="' + hiddenCount + '" aria-controls="ha-models-' + meta.key + '" aria-expanded="false">View all supported models (' + hiddenCount + ' more)</button>' : '') +
        notesHtml +
      "</article>";
    };

    const placeHowCards = () => {
      howCards.forEach((card) => {
        const heading = card.querySelector("h3");
        if (heading && !card.dataset.originalHeading) card.dataset.originalHeading = heading.textContent;
        if (heading && card.dataset.originalHeading) heading.textContent = card.dataset.originalHeading;
        card.classList.remove("is-inline");
        card.hidden = false;
        howToGridEl.appendChild(card);
      });

      routeMeta.forEach((meta) => {
        const card = howCards.find((item) => item.dataset.haHow === meta.key);
        const mount = groupsEl.querySelector('[data-ha-method="' + meta.key + '"]');
        if (!card) return;
        if (!mount) {
          card.hidden = true;
          return;
        }
        const heading = card.querySelector("h3");
        if (heading) heading.textContent = "How to listen";
        card.classList.add("is-inline");
        mount.appendChild(card);
      });

      root.querySelector(".how-to").hidden = true;
    };

    const scrollToSection = (element, focus = false) => {
      const header = Array.from(document.querySelectorAll("sticky-header, .shopify-section-header-sticky"))
        .find((item) => item.getBoundingClientRect().height > 0);
      const top = element.getBoundingClientRect().top + window.scrollY - (header ? header.getBoundingClientRect().height : 52) - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      if (focus) {
        element.tabIndex = -1;
        element.focus({ preventScroll: true });
      }
    };

    const renderBrand = (brand, scrollToModels = false) => {
      [brandNameEl.parentElement, groupsEl].forEach((section) => { section.style.display = ""; });
      selectedBrand = brand;
      choiceEl.hidden = false;
      const brandRows = normalizedRows.filter((row) => row.brand === brand);
      brandsEl.querySelectorAll("button").forEach((button) => {
        const active = button.dataset.brand === brand;
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
      });
      brandNameEl.innerHTML = brandLogo(brand, assets, true) + '<h2 class="ha-visually-hidden">' + escapeHtml(brand) + "</h2>";
      howCards.forEach((card) => howToGridEl.appendChild(card));
      groupsEl.innerHTML = routeMeta.map((meta) => renderRoute(brandRows, meta)).join("");
      placeHowCards();
      setGuide(brand);
      revealSearchModels();
      alignModelHeadings();
      requestAnimationFrame(alignModelHeadings);
      saveVisit();
      if (scrollToModels) {
        requestAnimationFrame(() => {
          scrollToSection(brandNameEl.parentElement, true);
        });
      }
    };

    brandsEl.innerHTML = brands.map((brand, index) =>
      '<button type="button" role="tab" aria-label="' + escapeHtml(brand) + '" data-brand="' + escapeHtml(brand) + '" aria-selected="' + "false" + '" tabindex="' + (index === 0 ? "0" : "-1") + '">' +
        brandLogo(brand, assets, false) +
      "</button>"
    ).join("");

    brandsEl.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-brand]");
      if (button) renderBrand(button.dataset.brand, true);
    });

    brandsEl.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      const buttons = Array.from(brandsEl.querySelectorAll("button[data-brand]")).filter((button) => !button.hidden);
      const current = buttons.indexOf(event.target.closest("button[data-brand]"));
      if (current < 0) return;
      event.preventDefault();
      let next = current;
      if (event.key === "ArrowLeft") next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === "ArrowRight") next = (current + 1) % buttons.length;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = buttons.length - 1;
      buttons[next].focus();
      renderBrand(buttons[next].dataset.brand);
    });

    const brandPickerEl = root.querySelector(".bar") || brandsEl;
    brandPickerEl.id = "hearing-aid-brand-picker";
    const filterBrands = () => {
      const query = searchEl.value.trim().toLocaleLowerCase();
      let count = 0;
      brandsEl.querySelectorAll("button[data-brand]").forEach((button) => {
        const matches = !query || normalizedRows.some((row) => row.brand === button.dataset.brand && (row.brand + " " + row.model).toLocaleLowerCase().includes(query));
        button.hidden = !matches;
        if (matches) count++;
      });
      const visible = Array.from(brandsEl.querySelectorAll("button[data-brand]")).filter((button) => !button.hidden);
      const active = visible.find((button) => button.dataset.brand === selectedBrand) || visible[0];
      visible.forEach((button) => { button.tabIndex = button === active ? 0 : -1; });
      clearSearchEl.hidden = !query;
      searchStatusEl.hidden = !query;
      searchStatusEl.textContent = count ? count + (count === 1 ? " brand matches. " : " brands match. ") + "Choose a brand to view its models." : "No matches. Check the spelling, clear the search, or contact support below.";
    };
    searchEl.addEventListener("input", () => {
      filterBrands();
      revealSearchModels();
    });
    root.querySelectorAll('[data-ha-option]').forEach((link) => link.addEventListener("click", (event) => {
      const target = root.querySelector(link.getAttribute("href"));
      if (!target) return;
      event.preventDefault();
      scrollToSection(target, true);
    }));
    clearSearchEl.addEventListener("click", () => {
      searchEl.value = "";
      filterBrands();
      searchEl.focus();
    });
    root.querySelectorAll('a[href="#hearing-aid-brand-picker"]').forEach((link) => link.addEventListener("click", (event) => {
      if (link.getAttribute("href") !== "#hearing-aid-brand-picker") return;
      event.preventDefault();
      searchEl.value = "";
      filterBrands();
      scrollToSection(brandPickerEl);
      searchEl.focus({ preventScroll: true });
    }));
    directInstructionEl.textContent = "Direct Auracast availability depends on your hearing aid brand and model.";
    directGuideEl.hidden = false;
    directGuideEl.href = "#hearing-aid-brand-picker";
    directGuideEl.innerHTML = 'Choose your hearing aid brand';
    directScopeEl.hidden = false;
    directScopeEl.classList.remove("is-coming-soon");
    directScopeEl.textContent = "Select your brand to see verified models and its connection guide.";
    directGuideCoverEl.hidden = true;
    directGuideCoverImageEl.removeAttribute("src");
    directGuideCoverImageEl.alt = "";

    [brandNameEl.parentElement, groupsEl].forEach((section) => { section.style.display = "none"; });
    if (returnState && brands.includes(returnState.brand)) {
      renderBrand(returnState.brand);
      requestAnimationFrame(() => window.scrollTo({ top: returnState.scrollY || 0, behavior: "instant" }));
    }
  });
})();


